export interface StageRecipe {
  title: string
  subtitle: string
  protocolUrl?: string
  protocolLabel?: string
  risk?: string
  framable?: boolean
  steps?: string[]
}

export const STAGE_RECIPES: Record<string, StageRecipe> = {
  STAKE: {
    title: 'Stake',
    subtitle: 'Stake SOL → jupSOL via Jupiter',
    protocolUrl: 'https://jup.ag/stake?tab=Liquid',
    protocolLabel: 'Jupiter Stake',
    framable: false,
    risk: 'LST smart-contract risk; jupSOL depeg in extreme conditions.',
  },
  LEND: {
    title: 'Lend',
    subtitle: 'Deposit jupSOL into Jupiter Lend as collateral',
    protocolUrl: 'https://jup.ag/lend',
    protocolLabel: 'Jupiter Lend',
    framable: false,
    risk: 'Protocol liquidation risk if health factor drops below 1.',
  },
  BORROW: {
    title: 'Borrow',
    subtitle: 'Borrow USDC against your jupSOL collateral',
    protocolUrl: 'https://jup.ag/lend/borrow',
    protocolLabel: 'Jupiter Borrow',
    framable: false,
    risk: 'Health factor must stay above 1. Monitor your position.',
  },
  LP: {
    title: 'LP',
    subtitle: 'Provide SOL/USDC liquidity on Raydium CLMM',
    protocolUrl: 'https://raydium.io/liquidity/increase/?mode=add',
    protocolLabel: 'Raydium',
    framable: false,
    risk: 'Impermanent loss if price moves outside your selected range.',
  },
  HEDGE: {
    title: 'Hedge',
    subtitle: 'Open a SOL perp short to protect LP exposure',
    protocolUrl: 'https://jup.ag/perps',
    protocolLabel: 'Jupiter Perps',
    framable: false,
    risk: 'Funding cost eats into yield if SOL trends up strongly.',
  },
  LOOP: {
    title: 'Loop',
    subtitle: 'Recursive lend-borrow to amplify staking yield',
    risk: 'Compounding liquidation risk. Unwind loops before health factor drops below 1.5.',
  },
}
